import { Injectable } from '@angular/core';
import { isPlatformBrowser, } from '@angular/common';
import { Inject, PLATFORM_ID } from '@angular/core';

import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { AuthService } from './auth.service';
@Injectable()
export class AuthGuard implements CanActivate {
  currentRoute: any;
  constructor(
    private router: Router,
    private auth: AuthService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {

    if (this.auth.isLoggedIn()) {
      return true;
    } else {
      let base = window.location.href.indexOf('=');
      let urlSubstr = window.location.href.substring(0, base);

      if (urlSubstr == window.location.origin + '/lead-booking?vc' || urlSubstr == window.location.origin + '/lead-booking?dealer') {
        if (isPlatformBrowser(this.platformId)) {
          if (route.queryParams['dealer']) {
            localStorage.setItem('dealercd', route.queryParams['dealer'])
          }
          if (route.queryParams['vc']) {
            localStorage.setItem('vc', route.queryParams['vc'])
          }
          localStorage.setItem('previousUrl', '/lead-booking?dealer');
          this.router.navigateByUrl('/login');

        }
      }
      else {
        if (isPlatformBrowser(this.platformId)) {

        this.router.navigateByUrl('/login');
        localStorage.setItem('previousUrl', state.url);
        }
      }
      return false;
    }



  }

  canActivateChild(

  ): Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {

    if (this.auth.isLoggedIn()) {
      return true;
    }

    this.router.navigateByUrl('/');
    return false;

  }
}
